import { SwodocLang } from '@alberta/swodoc-lang';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SwodocEvaluationService {
  public eval(input) {
    const lang = new SwodocLang();
    const { formula, assignments } = input;
    for (const key in assignments) {
      if (assignments.hasOwnProperty(key)) {
        // swodoc lang can handle undefined but not NaN for calculations
        // so if an audit uses calculations and a value is deleted in the frontend that is part of the calculation
        // it is received here as NaN (3+4+NaN -> Does not work)
        // we have to transform it to undefined so the calculation can be done (3+4+undefined -> Works)
        // Use Number.isNaN instead of isNaN to avoid settings assignments[key] to undefined when assignments[key] is a string
        if (Number.isNaN(assignments[key])) {
          assignments[key] = undefined;
        }
        lang.assign(`[${key}]`, assignments[key]);
      }
    }

    let value = null;
    try {
      value = lang.eval(formula);
    } catch (e) {}
    return value;
  }
}
